import { ModeToggle } from "@/components/mode-toggle";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { SystemErrorPage } from "@/pages";
import * as Sentry from "@sentry/react";
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <Sentry.ErrorBoundary fallback={SystemErrorPage}>
      <ThemeProvider defaultTheme="system" storageKey="pages-theme">
        <div className="fixed right-4 top-4">
          <ModeToggle />
        </div>
        <main>
          <Outlet />
          <Toaster />
        </main>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  );
}

export { Layout };
